var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote"},[_c('div',{staticClass:"quote__text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"quote__author"},[_vm._v(" "+_vm._s(_vm.author)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }